import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { RewardProvider } from "../../shared/providers/rewards.provider";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RewardTypeModel } from "../../shared/models/rewards";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';


@Component({
  selector: 'app-type-rewards',
  templateUrl: './type-rewards.component.html',
  styleUrls: ['./type-rewards.component.scss']
})
export class TypeRewardsComponent implements OnInit {
  addOrEditRewardType: String;
  rewardCategory: any= [];
  moduleList:any = []
  subCategory:any = []
  formGroup;
  deletePopupUiData;
  moduleId:any =''


  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public rewardProvider: RewardProvider,
    public adminDataProvider: AdminDataProvider,
  ) { }

  ngOnInit() {
    this.getModule()
   }
   getModule(){
    this.apiService.get(this.apiConfig.getModules).subscribe(
      (res: any) => {
        this.moduleList = res.data as RewardTypeModel[];
      },(err)=>{
        this.toast.Error(err.body.data.message);

      }
    );
   }
  getRewardCategory(e){
    this.moduleId = e;
    this.apiService.get(this.apiConfig.rewardBrands+`?module_id=${e}`).subscribe(
      (res: any) => {
        this.rewardCategory = res.data as RewardTypeModel[];
      },(err)=>{
        this.toast.Error(err.body.data.message);
      }
    );
    }
    rewardType:any = ''
getSubCategory(e){
  this.rewardType = e;
  this.apiService.get(this.apiConfig.rewardTypes+`?program_id=1&id=${this.moduleId}&reward_type=${this.rewardType}`).subscribe(
    (res: any) => {
      this.subCategory = res.data as RewardTypeModel[];
    }
  );
}
  addRewardType(targetModal) {
    this.addOrEditRewardType = "add";
    this.formGroup = this.fb.group({
      program_id: 1,
      reward_type_id:new FormControl("", [Validators.required]),
      reward_name: new FormControl("", [Validators.required]),
      id: new FormControl("", [Validators.required]),
    });

    this.showRewardTypeModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editRewardType(targetModal, reward) {
    console.log(reward);
    this.addOrEditRewardType = "edit";
    this.formGroup = this.fb.group({
      program_id: 1,
      reward_type_id:new FormControl(reward.reward_type_id, [Validators.required]),
      reward_name: new FormControl(reward.reward_name, [Validators.required]),
      id: new FormControl(reward.id),
    });

    this.showRewardTypeModal(targetModal);
  }

  deleteRewardType(targetModal, reward) {
    this.addOrEditRewardType = "delete";
    this.deletePopupUiData = reward.reward_type_name;

    this.formGroup = this.fb.group({
      id: reward.id,
      program_id:1,
      flag: 0,
    });
    this.showRewardTypeModal(targetModal);
  }

  showRewardTypeModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  submitted = false;

  onSubmitRewardType(formData: RewardTypeModel) {
    console.log(formData)
    // return
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }


    if (this.addOrEditRewardType == "add") {
      let rewardType = this.rewardType;
      this.apiService.post(this.apiConfig.addRewardTypes,formData).subscribe((res:any)=>{
        console.log(res)
        this.toast.Success("Added reward Successfully");
        this.getModule()
        this.getSubCategory(rewardType)
      },(err)=>{
        console.log(err)
        this.toast.Error(err);
      })
    } else if (this.addOrEditRewardType == "edit") {
      let rewardType = this.rewardType;
      this.apiService.post(this.apiConfig.updateRewardTypes,formData).subscribe((res:any)=>{
        console.log(res)
        this.toast.Success("Updated successfully.")
        this.getSubCategory(rewardType)
      },(err)=>{
        this.toast.Error(err);
      })
    } else if (this.addOrEditRewardType == "delete") {
      let rewardType = this.rewardType;
      this.apiService.post(this.apiConfig.deleteRewardTypes,formData).subscribe((res:any)=>{
        console.log(res)
        this.toast.Success("Deleted successfully.")
        this.getSubCategory(rewardType)
      },(err)=>{
        this.toast.Error(err);
      })
    }
    this.modalService.dismissAll();
  }
}

